import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import 'react-slidedown/lib/slidedown.css'
import Select from 'react-select'
import { SlideDown } from 'react-slidedown'
import { SELECT_ALL, DESELECT_ALL, LoadingLevelsSpinner } from './utils'
import ItemRow from '../dtcs/TATMappings/ConnectorMapping/ItemRow'
import { useParams } from 'react-router-dom'
import { getRequest } from '../../services/base'

const HarnessLevelsSearchTable = (props) => {
  const {
    harness,
    onSelectHarnessLevel,
    onClearHarness,
    toggleHarnesses,
    harnessIsOpened,
    checkedHarnessLevels,
  } = props
  const { vehicle } = useParams()
  const [searchLevelNameQuery, setSearchLevelNameQuery] = useState(null)
  const [selectedOptionCode, setSelectedOptionCode] = useState(null)
  const [openedConnectors, setOpenedConnectors] = useState([])
  const [harnessLevels, setHarnessLevels] = useState([])
  const [optionCodes, setOptionCodes] = useState([])
  const [loadingLevels, setLoadingLevels] = useState(false)

  useEffect(() => {
    fetchHarnessesLevels()
  }, [])

  const toggleSpinner = (value) => {
    setLoadingLevels(value)
  }

  const fetchHarnessesLevels = async (optionCode) => {
    toggleSpinner(true)

    let response = await getRequest(
      `/api/harnesses/harness_levels/${harness.id}/?vehicle=${vehicle}&search=${
        searchLevelNameQuery ? searchLevelNameQuery : ''
      }&option_code=${optionCode?.value ? optionCode?.value : ''}`
    )

    let optionCodesRes =
      response?.optionCodes?.length > 0 ? response?.optionCodes : []
    setHarnessLevels(response?.levels?.length > 0 ? response?.levels : [])
    setOptionCodes([
      { label: 'Any', value: null },
      ...optionCodesRes.map((o) => ({
        value: o.id,
        label: o.name,
      })),
    ])
    toggleSpinner(false)
  }

  const setSearchQuery = (event) => {
    setSearchLevelNameQuery(event.target.value)
  }

  const selectOptionCode = (option) => {
    setSelectedOptionCode(option)
    fetchHarnessesLevels(option)
  }

  const toggleHarnessesLevels = (selection) => {
    props.onSelectHarnessLevel(
      harnessLevels.map((hl) => hl.id),
      selection
    )
  }

  const toggleConnectors = (e, hl) => {
    e.stopPropagation()

    let tempOpenedConnectors = [...openedConnectors]
    if (tempOpenedConnectors.includes(hl.id)) {
      tempOpenedConnectors = tempOpenedConnectors.filter((m) => m !== hl.id)
    } else {
      tempOpenedConnectors.push(hl.id)
    }
    setOpenedConnectors(tempOpenedConnectors)
  }

  const connectorIsOpened = (hl) => {
    return openedConnectors.includes(hl.id)
  }

  return (
    <div className="flex items-stretch">
      <div className="flex-1 w-1/2 flex flex-col bg-tracer-darker-blue px-4 pb-4 flex-grow">
        <div className="text-white mb-6">
          <div className="flex">
            <div className="text-white w-4/5">
              <div>Harness</div>
              <div className="font-bold">
                {harness.name || harness.harness_id}
              </div>
            </div>
            <span
              onClick={() => onClearHarness(harness, harnessLevels)}
              className="cursor-pointer my-4 underline text-white text-center w-1/5"
            >
              Clear
            </span>
          </div>
          <div className="flex">
            <span
              onClick={() => toggleHarnesses(harness)}
              className="cursor-pointer underline text-white"
            >
              Select Harness Levels
            </span>
          </div>
        </div>
        <SlideDown closed={!harnessIsOpened(harness)}>
          <div className="w-full">
            <form
              className="flex flex-col w-full space-y-2 pb-5"
              action={'searchPath'}
              acceptCharset="UTF-8"
              method="get"
            >
              <div className="flex space-x-5">
                <div className="w-2/3">
                  <input
                    autoComplete="off"
                    className="w-full bg-white h-10 px-5 pr-5 rounded focus:outline-none"
                    placeholder="Enter Level Name"
                    type="search"
                    name="q[full_cont]"
                    value={searchLevelNameQuery || ''}
                    onChange={setSearchQuery}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault()
                        fetchHarnessesLevels()
                      }
                    }}
                  />
                </div>
                <div className="w-1/3">
                  <Select
                    name={'q[acronym_cont]'}
                    inputName={'blank'}
                    classNamePrefix="dtcs-filter"
                    isMulti={false}
                    value={selectedOptionCode}
                    options={optionCodes}
                    placeholder={'Code'}
                    className="w-full"
                    onChange={selectOptionCode}
                  />
                </div>
              </div>
            </form>
            <button
              onClick={() => toggleHarnessesLevels(SELECT_ALL)}
              className="btn my-2"
            >
              Select All
            </button>
            <button
              onClick={() => toggleHarnessesLevels(DESELECT_ALL)}
              className="btn my-2 ml-3"
            >
              Deselect All
            </button>
          </div>
          <div className="flex-auto overflow-auto scrollbar-height">
            {loadingLevels && <LoadingLevelsSpinner />}
            {harnessLevels.map((hl, i) => (
              <div
                key={`${i}-harness-level`}
                className="flex flex-row items-center bg-white w-full"
              >
                <ItemRow
                  name={hl.name}
                  inputName={'harness_level_ids[]'}
                  value={hl.id}
                  onChange={() => onSelectHarnessLevel([hl.id])}
                  isChecked={checkedHarnessLevels.includes(hl.id)}
                  description={''}
                >
                  {hl.connector_names.length > 0 && (
                    <div className={'text-sm max-h-5 overflow-hidden'}>
                      <span
                        onClick={(e) => toggleConnectors(e, hl)}
                        className={'text-blue-500 underline'}
                      >
                        View Connectors
                      </span>
                      <SlideDown
                        closed={!connectorIsOpened(hl)}
                        className={'pt-2 pb-1 max-h-1 overflow-y-auto'}
                        style={{ maxHeight: '350px' }}
                      >
                        {hl.connector_names.map((n) => (
                          <p key={`conn-name-level-${n}-${hl.id}`}>{n}</p>
                        ))}
                      </SlideDown>
                    </div>
                  )}
                </ItemRow>
              </div>
            ))}
          </div>
        </SlideDown>
      </div>
    </div>
  )
}

HarnessLevelsSearchTable.propTypes = {
  searchLevelNameQuery: PropTypes.string,
  harness: PropTypes.object.isRequired,
  onClearHarness: PropTypes.func.isRequired,
  onSelectHarnessLevel: PropTypes.func.isRequired,
  checkedHarnessLevels: PropTypes.array.isRequired,
}

export default HarnessLevelsSearchTable
